module.exports = __webpack_public_path__ + "media/images/front/team/jose_robles-c475b1a6d570d7a0965acfc03df80b00.jpg";